import { Box, Button, Stack, Typography } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import CareNeedsIcons from 'src/assets/images/care-needs/care-needs-icons.avif';
import SagePedalsBackground from 'src/assets/images/care-needs/sage-pedal-background-1.avif';
import PageFooter from 'src/components/PageFooter';
import PageHeader from 'src/components/PageHeader';
import { useTeamMemberData } from 'src/hooks/useTeamMemberData';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';
import { getTeamMemberDisplayName } from 'src/utils/nameUtils';

export const Route = createFileRoute('/(app)/care/adls/intro')({
    component: AdlsIntroComponent,
});

function AdlsIntroComponent() {
    const navigate = useNavigate();
    const { careRecipient } = useTeamMemberData();
    const handleContinue = () => {
        navigate({ to: '/care/adls/edit' });
    };
    return (
        <InnerMaxWidthContainer
            wrapperPropsSx={{
                backgroundImage: `url(${SagePedalsBackground})`,
                backgroundSize: 'contain',
                backgroundPosition: 'top left',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
            }}
        >
            <PageHeader />
            <Box
                sx={{
                    py: 6,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    animation: 'fadeSlideIn 0.6s ease-out',
                    '@keyframes fadeSlideIn': {
                        from: {
                            opacity: 0,
                            transform: 'translateY(-20px)',
                        },
                        to: {
                            opacity: 1,
                            transform: 'translateY(0)',
                        },
                    },
                }}
            >
                <Box
                    component="img"
                    src={CareNeedsIcons}
                    alt="Care Needs Icons"
                    sx={{ width: '100%', height: '100%' }}
                />
            </Box>
            <Stack sx={{ gap: 2 }}>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                    First, tell us about what{' '}
                    {getTeamMemberDisplayName(careRecipient, {
                        firstOnly: true,
                        usePreferred: true,
                    })}{' '}
                    needs help with.
                </Typography>
                <Typography variant="body1">
                    You don't have to answer everything at once, and can update it at anytime.
                </Typography>
                <Typography variant="body1">
                    Enter notes that help those assisting personalize the care for{' '}
                    {getTeamMemberDisplayName(careRecipient, {
                        firstOnly: true,
                        usePreferred: true,
                    })}
                    .
                </Typography>
                <Typography variant="body1">
                    This information will be available for any caregivers, family, or friends you
                    invite to Sage Home.
                </Typography>
            </Stack>
            <PageFooter>
                <Button variant="contained" color="primary" fullWidth onClick={handleContinue}>
                    Continue
                </Button>
            </PageFooter>
        </InnerMaxWidthContainer>
    );
}
